import { Autocomplete, MenuItem, TextField } from "@mui/material";
import useRubros from "../../Products/hooks/rubros.hook";
import { IRubro } from "../../AdminProducts/types/producto";

interface DesplegableRubrosPadresProps {
  onChange: (param?: any) => void;
  prevValue?: any;
}

export const flattenRubrosHierarchy = (rubros: IRubro[]): IRubro[] => {
  const flattened: IRubro[] = [];
  for (const rubro of rubros) {
    flattened.push(rubro);
    if (rubro.rubros?.length > 0) {
      flattened.push(...flattenRubrosHierarchy(rubro.rubros));
    }
  }
  return flattened;
};

const ninguno: IRubro = {
  activo: true,
  listable: true,
  idEspcacioTemplate: 0,
  idrubro: 0,
  nombre: "Ninguno",
  orden: 0,
  idrubroPadre: 0,
  nombreAnalytics: "Ninguno",
  rubros: [],
  precioMinimo: 0,
  unidadDeMedidaList: [],
  productoAtributoList: [],
  monedaList: [],
};

const DesplegableRubrosPadres = ({
  onChange,
  prevValue,
}: DesplegableRubrosPadresProps) => {
  const { rubros } = useRubros();
  const rubrosFlatted = [ninguno, ...flattenRubrosHierarchy(rubros)];

  return (
    <Autocomplete
      options={rubrosFlatted}
      getOptionLabel={(rubro: IRubro) => rubro.nombreAnalytics || ""}
      value={prevValue === 0 ? ninguno : prevValue}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          onKeyPress={(e) => e.key === "Enter"}
          variant="outlined"
          placeholder="Seleccione"
          InputLabelProps={{ disableAnimation: true }}
        />
      )}
      renderOption={(props, rubro) => (
        <MenuItem {...props} value={rubro.idrubro}>
          {rubro.nombreAnalytics}
        </MenuItem>
      )}
    />
  );
};

export default DesplegableRubrosPadres;